import script from "./payQrcode.vue?vue&type=script&setup=true&lang=js"
export * from "./payQrcode.vue?vue&type=script&setup=true&lang=js"

import "./payQrcode.vue?vue&type=style&index=0&id=7b6a203e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6a203e"]])

export default __exports__